(function () {
  'use strict';
  var money = function (cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',') + ' EUR';
  };

  /* ---------- Header : transparent sur hero, solide au scroll ---------- */
  var header = document.querySelector('.etk-header');
  if (header) {
    var firstSection = document.querySelector('#MainContent > .shopify-section');
    if (firstSection && firstSection.querySelector('.etk-hero') && header.dataset.transparent === 'true') {
      document.body.classList.add('etk-has-hero');
    }
    var announce = document.querySelector('.etk-announcement');
    var scrollTop = function () {
      return window.scrollY || document.documentElement.scrollTop || 0;
    };
    var measure = function () {
      var h = announce ? announce.offsetHeight : 0;
      document.documentElement.style.setProperty('--etk-announce-offset', Math.max(0, h - scrollTop()) + 'px');
      document.documentElement.style.setProperty('--etk-header-height', header.offsetHeight + 'px');
    };
    var onScroll = function () {
      header.classList.toggle('is-solid', scrollTop() > 24);
      measure();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', measure, { passive: true });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      ro.observe(header);
      if (announce) ro.observe(announce);
    }
    onScroll();
  }

  /* ---------- Drawers génériques (menu, panier, lookbook) ---------- */
  var overlay = document.querySelector('.etk-overlay');
  var openDrawer = function (sel) {
    var d = document.querySelector(sel);
    if (!d) return;
    d.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('etk-lock');
  };
  var closeAll = function () {
    document.querySelectorAll('.etk-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('etk-lock');
  };
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('etk-overlay')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- Menu mobile multi-niveaux ---------- */
  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-nav-next]');
    if (next) {
      next.closest('.etk-nav-panels').style.transform = 'translateX(' + (parseInt(next.getAttribute('data-nav-next'), 10) * -100) + '%)';
    }
    var back = e.target.closest('[data-nav-back]');
    if (back) {
      back.closest('.etk-nav-panels').style.transform = 'translateX(' + (parseInt(back.getAttribute('data-nav-back'), 10) * -100) + '%)';
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('etk-overlay')) {
      var panels = document.querySelector('[data-nav-panels]');
      if (panels) panels.style.transform = 'translateX(0)';
    }
  });

  /* ---------- Cart drawer : rendu ---------- */
  var renderCart = function (cart) {
    var count = document.querySelectorAll('[data-cart-count]');
    count.forEach(function (el) { el.textContent = cart.item_count; });
    var body = document.querySelector('[data-cart-items]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<p class="etk-cart-empty">Votre panier est vide</p>';
    } else {
      body.innerHTML = cart.items.map(function (it) {
        return '<div class="etk-cart-item" data-line-key="' + it.key + '">' +
          '<div class="etk-cart-item__img">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="etk-cart-item__info">' +
            '<p class="etk-cart-item__vendor">' + (it.vendor || '') + '</p>' +
            '<p class="etk-cart-item__title">' + it.product_title + '</p>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="etk-cart-item__variant">' + it.variant_title + '</p>' : '') +
            '<div class="etk-cart-item__row">' +
              '<div class="etk-qty"><button type="button" data-qty-change="-1" aria-label="Réduire">−</button><span>' + it.quantity + '</span><button type="button" data-qty-change="1" aria-label="Augmenter">+</button></div>' +
              '<span class="etk-cart-item__price">' + money(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="etk-cart-item__remove" data-qty-change="0" aria-label="Retirer">&times;</button>' +
        '</div>';
      }).join('');
    }
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.items_subtotal_price);
    var bar = document.querySelector('[data-shipping-bar]');
    if (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) * 100;
      var remaining = Math.max(0, threshold - cart.items_subtotal_price);
      var pct = threshold > 0 ? Math.min(100, Math.round(cart.items_subtotal_price / threshold * 100)) : 100;
      bar.querySelector('[data-shipping-fill]').style.width = pct + '%';
      bar.querySelector('[data-shipping-text]').textContent = remaining === 0
        ? 'Livraison offerte'
        : 'Plus que ' + money(remaining).replace(' EUR', '') + ' pour la livraison offerte';
    }
  };
  var fetchCart = function () {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  };

  /* ---------- Interception globale des formulaires produit ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('disabled', ''); btn.dataset.label = btn.textContent; btn.textContent = 'Ajout...'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(fetchCart)
      .then(function () { openDrawer('#EtkCartDrawer'); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.textContent = btn.dataset.label; }
      });
  });

  /* ---------- Quantités dans le drawer ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var line = btn.closest('[data-line-key]');
    if (!line) return;
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var current = parseInt(line.querySelector('.etk-qty span') ? line.querySelector('.etk-qty span').textContent : '1', 10);
    var qty = delta === 0 ? 0 : current + delta;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.getAttribute('data-line-key'), quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* ---------- Carousels scroll-snap : flèches ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-carousel-track]');
    wrap.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 14 : 300;
        track.scrollBy({ left: b.hasAttribute('data-carousel-next') ? step : -step, behavior: 'smooth' });
      });
    });
  });

  /* ---------- Accordéons ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-accordion]');
    if (!head) return;
    var item = head.parentElement;
    item.classList.toggle('is-open');
  });

  /* ---------- Variantes produit ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-variants-json]').textContent);
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var submit = root.querySelector('[type="submit"]');
    var update = function () {
      var selected = [];
      root.querySelectorAll('.etk-option').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      var variant = data.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      if (!variant) return;
      idInput.value = variant.id;
      priceEl.textContent = money(variant.price).replace(' EUR', '');
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price).replace(' EUR', '');
          compareEl.hidden = false;
          priceEl.classList.add('etk-price--sale');
        } else {
          compareEl.hidden = true;
          priceEl.classList.remove('etk-price--sale');
        }
      }
      if (variant.available) {
        submit.removeAttribute('disabled');
        submit.textContent = 'Ajouter au panier';
      } else {
        submit.setAttribute('disabled', '');
        submit.textContent = 'Épuisé';
      }
    };
    root.addEventListener('change', update);
    update();
  });

  window.EtkCart = {
    refresh: fetchCart,
    open: function () { openDrawer('#EtkCartDrawer'); }
  };

  fetchCart();
})();
